<template>
    <form id="sidebarSearchForm" class="search-form row" style="margin: 10px 40px;" > <!--@submit.prevent="onSubmit"-->
          <dynButton :configs="{ID: 'buttons.expand-search', visible: true}" :icon="angleIcon"  btnClasses="btn-primary"
          :styleObj="{
            'position': 'absolute', 'left': '60px','top': '110px', 'z-index': '999', 
            'width': '28px', 'height': '26px', 'float': 'right'}"
            :exec="showOtherFields">
          </dynButton>
          
          <label style="color:rgb(69, 70, 72); position: absolute; top: 112px; left: 100px;">{{type == 'criteria' ? $Jed.firstUpperTranslate('search criteria') : $Jed.firstUpperTranslate('filter')}}</label>
          <transition name="expand">
            <ul v-show="expandSearch" class="searchfieldWrapper" style="margin-top: 30px; margin-left: 5px;"> 
                <table style="width: 100%;">
                    <tr><th style="width: 25%;"></th><th style="width: 65%;"></th><th style="width: 10%;"></th></tr>
                    <tr v-for="f in fields" v-show="f.always || expandSearch">
                    <td v-if="f.visible"><span>{{f.label}}</span></td>
                    <td v-if="f.visible">
                        <input-w v-if="(f.type == 'text' && f.field != 'mat') || f.field == 'mat'">
                            <input v-if="f.type == 'text' && f.field != 'mat'" type="text" class="searchfield" :id="'formfield-'+f.field" :disabled="disableInput" :placeholder="f.placeholder" v-model="filtro[f.field]" @keydown.enter.prevent="type=='criteria' ? applyFilter() : showResults() ">
                            <input v-if="f.field == 'mat'" id='mat' type="text" class="searchfield" :placeholder="f.placeholder" v-model="filtro[f.field]" @input="disableOthers()" :disabled="macInserted" @keydown.enter.prevent="applyFilter()">
                        </input-w> 

                        <input style="margin-left: -140px; height: 17px;" v-if="f.type == 'checkbox' && f.field=='ricerca_in_matricola'" type="checkbox" id="checkbox" v-model="filtro[f.field]" @input="enableOthers()"></input>
                        <input style="margin-left: -140px; height: 17px;" v-if="f.type == 'checkbox' && f.field=='considera_sostitutivi'" type="checkbox" id="checkbox" v-model="filtro[f.field]"></input>
                        <!--<span v-if="f.field=='considera_sostitutivi'">{{"Se si, cerca anche i prodotti sostitutivi che iniziano con codice o contengono descrizione."}}</span>-->

                        <v-select v-if="f.type == 'select'" label="type" :options="f.choices" v-model="filtro[f.field]" @input="onDropdownChange(filtro[f.field], f.field)"
                            :placeholder="f.placeholder"
                            :selectStyle="{'background-color': 'white', height: '27px', 'font-family': 'inherit'}"
                            :tagStyle="{'background-color': '#ccc', color: 'white', padding: '3px', height:'22px', margin: '2px 4px', 'line-height': '15px'}"
                            :menuStyle="{position: 'relative', 'max-height': '150px', top: '0px'}"
                            :activeStyle="{'background-color': '#ccc', color: 'white'}"
                            :highStyle="{'background-color': '#ccc', color: 'white'}" :disabled="disableInput || disableSelectInput[f.field]"> 
                        </v-select>
                    </td>
                    <td v-if="f.delete_btn">
                        <button class="btn btn-primary" style="padding: 2px 5px; border-radius: 2px;" @click.prevent="emptyField(f.field)">
                            <i :class="$root.icons.clear" aria-hidden="true" style="margin-left: 0px;"></i>
                        </button>
                    </td>
                    </tr>
                </table>

                <dynButton :configs="{ID: 'buttons.search', visible: true}" :icon="$root.icons.search_btn" btnClasses="btn-primary"
                :exec="type=='criteria' ? applyFilter : showResults "
                    :styleObj="{
                    'z-index': '999', 'width': '214px', 'height': '26px', 'margin-top':'7px'}">
                </dynButton>
                
            </ul>
          </transition>
    </form>
</template>
<script>

import dynButton from "../dynamic/DynButton.vue";
import {Checkbox} from 'vue-checkbox-radio';
import vSelect from "../dynamic/vueSelectWrapper/components/Select.vue"
import InputW from '../dynamic/inputWrapper/inputWrapper.vue'

import { eventBus } from "../../eventbus.js";
import deepExtend from "deep-extend";
import utils from '../../../utils/utilities.js'

import search_mixin from '../../mixins/search_mixin.js';

export default {
    created: function(){
    },
    mounted: function(){
        console.log("FETCHING COLLECTIONS")
        this.fetchCollections().then(()=>{
            console.log('SearchFORM created')
            this.onCreate()
            
            console.log('SearchFORM mounted')
            this.onMount()
        })
    },
    props: {
        right: Boolean,
        modello: null,
        categoria: null,
        type: null
    },
    components: {
        dynButton,
        Checkbox,
        vSelect,
        InputW
    },
    mixins: [search_mixin],
    data: function(){
        var vm = this;
        return {
            filtro: {},
            expandSearch: true,
            angleIcon: vm.$root.icons.compressForm,//vm.$root.icons.expandForm,
            fields: [],
            configFields: null,
            disableInput: false,
            disableSelectInput: [],
            macInserted: false,
            nodes_coll: null,
            cur_lang: vm.$root.token.siglaLingua, 
            filtered: [],
            firstFilter: null,
            secondFilter: null,
            thirdFilter: null,
            lastIndex: null,
            catAttrColl: null,
            attributesColl: null
        }
    },
    watch: {
        //Alla scelta di categoria e modello nel wizard, i dropdown della ricerca vengono pre-compilati e disabilitati
        categoria: function(){
            this.filtro['fam'] = {id:0, type: this.categoria}
            this.disableSelectInput['fam'] = true;
        },
        modello: function(){
            this.filtro['mod'] = {id:0, type: this.modello}
            this.disableSelectInput['mod'] = true;
        }
    }, 
    methods: { 
        fetchCollections: function(){
            var vm = this;
            var promises = []
            promises.push(this.$root.fetchRegistryData("attrCategories", "GetAttrCategories", "collection").then((res) => {
                vm.catAttrColl = res;
            }))
            promises.push(this.$root.fetchRegistryData("attributes", "GetAttributes", "collection").then((res) => {
                vm.attributesColl = res;
            }))

            return Promise.all(promises);
        },
        async onCreate(){
            console.log('onCreate - SearchFORM created')
            console.log(this.type)
            var vm = this;
            if( this.$root.dbRegistry == null || this.$root.dbRegistry.collections.length == 0) {
                console.log("searchform - dbRegistry not loaded!");
                return;
            }
            var catAttrColl = this.catAttrColl;
            //________________________________________________________________________________________________________________
            //in base al tipo di SearchForm istanziato, inserisco i relativi field 
            if(this.type == 'criteria'){
                this.configFields = this.$Components["mainForm.searchFields"];
            }else if(this.type == 'model'){
                if(catAttrColl.data.length>0){
                    var cate = catAttrColl.find({st1: true}), //seleziono solo le categorie di attributi per il tab di ricerca 1 (modello)
                    filterFields = [];
                    console.log(cate)
                    for(var i=0; i<cate.length; i++){
                        filterFields.push({
                            "label": cate[i].nam[vm.cur_lang],
                            "type": "select",
                            "field": 'opa1-'+i, //cate[i].nam[vm.cur_lang],
                            "placeholder": vm.$Jed.firstUpperTranslate("select")+" "+cate[i].nam[vm.cur_lang].toLowerCase(),
                            "mandatory": cate[i].t1m ? cate[i].t1m : true, 
                            "position": i,
                            "choices": [],
                            "val_property": 'type',
                            "delete_btn": false,
                            "visible": true
                        })    
                    }
                    this.configFields = filterFields;
                }else{
                    console.log("SearchForm - collection not loaded!");
                    return;
                }
            }else if(this.type == 'merchandising'){
                if(catAttrColl.data.length>0){
                    var cate = catAttrColl.find({st2: true}), //seleziono solo le categorie di attributi per il tab di ricerca 2 (abbigliamento)
                    filterFields = [];
                    console.log(cate)
                    for(var i=0; i<cate.length; i++){
                        filterFields.push({
                            "label": cate[i].nam[vm.cur_lang],
                            "type": "select",
                            "field": 'opa2-'+i, //cate[i].nam[vm.cur_lang],
                            "placeholder": vm.$Jed.firstUpperTranslate("select")+" "+cate[i].nam[vm.cur_lang].toLowerCase(),
                            "position": i,
                            "choices": [],
                            "val_property": 'type',
                            "delete_btn": false,
                            "visible": true
                        })    
                    }
                    this.configFields = filterFields;
                }else{
                    console.log("SearchForm - collection not loaded!");
                    return;
                }
            }else if(this.type == 'marketing'){
                if(catAttrColl.data.length>0){
                    var cate = catAttrColl.find({st3: true}), //seleziono solo le categorie di attributi per il tab di ricerca 3 (articoli di stampa)
                    filterFields = [];
                    console.log(cate)
                    for(var i=0; i<cate.length; i++){
                        filterFields.push({
                            "label": cate[i].nam[vm.cur_lang],
                            "type": "select",
                            "field": 'opa3-'+i, //cate[i].nam[vm.cur_lang],
                            "placeholder": vm.$Jed.firstUpperTranslate("select")+" "+cate[i].nam[vm.cur_lang].toLowerCase(),
                            "position": i,
                            "choices": [],
                            "val_property": 'type',
                            "delete_btn": false,
                            "visible": true
                        })    
                    }
                    this.configFields = filterFields;
                }else{
                    console.log("SearchForm - collection not loaded!");
                    return;
                }
            }
            //field configurabili: faccio il merge dei field attuali e quelli in config (facendo prevalere quelli in config)
            var actualFields = this.fields;
            var mergedFields = [];
            if(this.configFields){ 
                for(var i in actualFields){ 
                    var shared = false;
                    for (var j in this.configFields){
                        if (this.configFields[j].field == actualFields[i].field) {
                            this.configFields[j] = deepExtend(actualFields[i], this.configFields[j])
                            shared = true;
                            break;
                        }
                    }
                    if(!shared){
                        mergedFields.push(actualFields[i])
                    }
                }
                mergedFields = mergedFields.concat(this.configFields);
            }
            for(var m in mergedFields){
                mergedFields[m].label = this.$Jed.firstUpperTranslate(mergedFields[m].label)
                mergedFields[m].placeholder = mergedFields[m].placeholder ? this.$Jed.firstUpperTranslate(mergedFields[m].placeholder) : ''
            }
            //ordino i field derivati dal merge in base alla property position
            mergedFields.sort(this.orderByPos)
            this.fields = mergedFields; 
            eventBus.$emit('readyFields', this.fields) 
            //________________________________________________________________________________________________________________
            
            eventBus.$on('emptyfield', function(id){
                vm.emptyField(id) 
            })
            
            this.filtro['fam'] = this.$store.getters.getCategory ? {id:0, type: this.$store.getters.getCategory} : '' 
            this.filtro['mod'] = this.$store.getters.getModel ? {id:0, type: this.$store.getters.getModel}  : '' 
        },
        async onMount(){
            var vm = this;
            if(vm.type == 'criteria'){ 
                //___________________________popolamento dropdown "Tipo" con i productTypes______________________________________
                var productTypesColl = this.$root.dbRegistry.getCollection('productTypes');
                var typesArray = productTypesColl.data,
                    types = [];
                for(var t = 0; t<typesArray.length; t++){
                    var typ = {
                        'id': t, 
                        'type': typesArray[t].des[vm.cur_lang] ? typesArray[t].des[vm.cur_lang] : typesArray[t].id, 
                        'iid': typesArray[t].iid,
                        'icon': typesArray[t].icn
                    } 
                    types.push(typ)
                    /* switch(typesArray[t].iid){
                        case 'part': 
                            typ.icon = vm.$root.icons.part; 
                            types.push(typ); 
                            break;
                        case 'category': 
                            typ.icon = vm.$root.icons.category;
                            types.push(typ); 
                            break;
                        case 'partstable': 
                            typ.icon = vm.$root.icons.partstable;
                            types.push(typ); 
                            break;
                        case 'machine': 
                            typ.icon = vm.$root.icons.machine;
                            types.push(typ); 
                            break;
                        case 'group': 
                            typ.icon = vm.$root.icons.group;
                            types.push(typ); 
                            break;
                        case 'transport': 
                            typ.icon = vm.$root.icons.transport;
                            types.push(typ); 
                            break;
                        case 'line': 
                            typ.icon = vm.$root.icons.line;
                            types.push(typ); 
                            break;
                        case 'kit': 
                            typ.icon = vm.$root.icons.kit;
                            types.push(typ); 
                            break;
                        case 'section': 
                            typ.icon = vm.$root.icons.section;
                            types.push(typ); 
                            break;
                    }  */
                }
                for(var f in vm.fields){
                    if(vm.fields[f].field=='prod_type'){
                        vm.fields[f].choices=types; 
                        break
                    }
                }
            }else if(vm.type == 'model' || vm.type == 'marketing' || vm.type == 'merchandising'){
                console.log(this.$root.dbRegistry)
                console.log(this.$root.dbRegistry.collections.length)
                if( this.$root.dbRegistry == null || this.$root.dbRegistry.collections.length == 0) {
                    console.log("searchform - dbRegistry not loaded!");
                    return;
                }
                //_________________________popolamento 1° dropdown______________________________________________________________
                var attributesColl = this.attributesColl,
                    catAttrColl = this.catAttrColl;
                console.log(attributesColl)
                console.log(catAttrColl)
                var left = attributesColl.chain(), //ResultSet
                    right = catAttrColl.find({$or: [{st1: true}, {st2: true}, {st3: true}]}), //seleziono solo le categorie di attributi ricercabili //Array 
                    joined = left.eqJoin(right, 'cat', 'id');

                joined = joined.data()
                for(var i=0; i<joined.length; i++){
                    if(joined[i].right.hasOwnProperty('nam')){
                        joined[i].left.cat = joined[i].right.nam[vm.cur_lang];
                    }
                }
                console.log(joined)
                for(var i=0; i<joined.length; i++){
                    //Presupppongo che il primo dropdown sia l'unico da popolare subito (gli altri vengono popolati a seguito del valore scelto per il primo)
                    var low  = joined[i].left.cat ? joined[i].left.cat.toLowerCase() : ''
                    if(vm.fields[0] && vm.fields[0].label.toLowerCase() == low){
                        var v = {
                            id: joined[i].left.id,
                            type: joined[i].left.nam[vm.cur_lang] ? joined[i].left.nam[vm.cur_lang] : joined[i].left.nam[vm.$root.token.defaultLang]
                        }
                        vm.fields[0].choices.push(v)
                    }
                }
            }
            //________________________________________________________________________________________________________________
            
            //________________________________________________________________________________________________________________
            //se la validità è "serial" e ho prescelto la matricola da wizard, inserisco il valore nel campo matricola (posso eseguire ricerche solo all'interno di quella matricola)
            if(vm.$Behaviors.updatesReference == 'serial'){
                var val = vm.$root.validity ? vm.$root.validity : sessionStorage.getItem("validity") ? JSON.parse(sessionStorage.getItem("validity")).value : null
                //console.log(val, sessionStorage.getItem("validity"))
                if(val){
                    vm.filtro['mat'] = val;
                    $('#mat').val(val);
                    vm.filtro['ricerca_in_matricola'] = true;
                    $('#checkbox').prop("checked", true)
                    vm.macInserted = true; //rende il campo matricola disabled
                }
            }

            eventBus.$on('clearForm', function(){
                vm.filtro = {}
                vm.disableSelectInput['fam'] = false;
                vm.disableSelectInput['mod'] = false;
            })
        },
        onDropdownChange:function(val, changedField){
            var vm = this,
                attributesColl = this.attributesColl;

            /*salvo in lastIndex l'indice dell'ultimo dropdown che è cambiato*/
            for(var f in vm.fields){
                if(vm.fields[f].field == changedField){
                    this.lastIndex = f
                    break;
                }
            }
            if(this.type != 'criteria'){
                if(val){
                    /*se è cambiato il primo dropdown, faccio la chiamata di ricerca*/
                    if(this.lastIndex==0){ 
                        /*disabilito gli altri dropdown*/
                        for(var f in vm.fields){
                            if(vm.fields[f].field != changedField){
                                this.disableSelectInput[vm.fields[f].field] = true
                            }
                        } 
                        /* resetto tutti i dropdown successivi all'ultimo che è cambiato */
                        for(var f in vm.fields){
                            if(f > parseInt(this.lastIndex)){ 
                                vm.fields[f].choices = [] 
                                vm.emptyField(vm.fields[f].field)
                            }
                        }
                        this.applyFilter();
                    }else{
                        /* resetto tutti i dropdown successivi all'ultimo che è cambiato */
                        for(var f in vm.fields){
                            if(f > parseInt(this.lastIndex)){ 
                                vm.fields[f].choices = [] 
                                vm.emptyField(vm.fields[f].field)
                            }
                        }
                        
                        /*filtra gli elementi in base a ciò che è contenuto nel filtro*/
                        this.filtered = this.filterPartialRes.filter(e=>{
                            var toCheck = []
                            for (var f in vm.filtro) {
                                if(vm.filtro[f]!=""){
                                    toCheck.push(vm.filtro[f]) //creo un array dai valori del filtro
                                }
                            }
                            var attrs = e.att
                            var op = toCheck.every(a => attrs.indexOf(a.id) > -1) //confronto l'array di attributi con l'array filtro
                            return op;
                        })
                        this.filterPartialRes = this.originalFilterPartialRes;    
                        
                        
                        /*di ogni risultato vado a prendere gli attributi per popolare il dropdown successivo*/
                        for (let i = 0; i < this.filtered.length; i++) {
                            var elem = this.filtered[i]
                            if(elem.att.includes(val.type)){ //se tra gli attributi c'è il valore selezionato nell'ultimo dropdown
                                for (let i = 0; i < elem.att.length; i++) {
                                    var attr = attributesColl.find({id: elem.att[i]})[0]
                                    var typ = attr.cat //categoria dell'attributo
                                    var val_l = attr.nam[vm.cur_lang] ? attr.nam[vm.cur_lang] : attr.nam[vm.$root.token.defaultLang]//valore da mettere nella tendina
                                    var v = {
                                        id: attr.id,
                                        type: val_l
                                    }
                                    for(var f in vm.fields){
                                        if(vm.fields[f].label.toLowerCase() == typ.toLowerCase()){
                                            if(!vm.fields[f].choices.some((c)=>{return c.id == v.id})){
                                                vm.fields[f].choices.push(v) //metto nei dropdown i risultati distinct
                                            }
                                        }
                                    }
                                }
                            }
                        }
                        for(var f in vm.fields){
                            vm.fields[f].choices.sort((a,b)=>{return ((a.id > b.id) ? 1 : ((a.id < b.id) ? -1 : 0))})
                        }
                    }
                }else{
                    this.filtered = this.filterPartialRes;
                }
            }
        },
        showOtherFields: function() {
            if (this.expandSearch) {
                this.angleIcon = this.$root.icons.expandForm;//this.angleIcon = this.$root.icons.compressForm;
                this.expandSearch = false;
            } else {
                this.angleIcon = this.$root.icons.compressForm;//this.angleIcon = this.$root.icons.expandForm;
                this.expandSearch = true;
            }
            this.$emit("resetHeight")
        },
        emptyField: function(field){
            this.filtro[field] = "";
        },
        orderByPos: function(f1, f2){
            if(f1.position < f2.position){
                return -1;
            }
            if(f1.position > f2.position){
                return 1;
            }
            return 0;
        },
        enableOthers: function(){
            if($('#mat').val() != '' && !$('#checkbox').prop("checked")){
                this.emptyField('mat');
            }else if($('#mat').val() != ''){ //disabilito gli altri campi solo se ho inserito la matricola
                if(this.disableInput){
                    this.disableInput = false; //abilito gli altri campi
                }else{
                    this.disableInput = true; //disabilito gli altri campi
                    for(var f in this.fields){ 
                        if(this.fields[f].field != "mat"){
                            this.filtro[this.fields[f].field] = null; //e li svuoto
                        }
                    }
                }
            }
        },
        disableOthers: function(){
            if(this.filtro.mat && this.filtro.mat.trim() != ''){
                //se non ho 'spuntato' il checkbox, disabilito gli altri campi quando inserisco la matricola
                if(!$('#checkbox').prop("checked"))this.disableInput = true;
            } else {
                this.disableInput = false;
            }
            
        }
    }
}
</script>
<style scoped>
    #sideOpen {
    display: inherit;
    }

    .sidebar-collapse .search-form {
    display: none;
    }

    .sidebar-collapse .loading-nav-spinner {
    display: none;
    }

    .search-form {
    margin: 0px 10px;
    border-style: none;
    display: flex;
    align-items: center;
    }

    .searchfieldWrapper {
    padding-left: 0px;
    overflow-y: auto;
    overflow-x: hidden;
    width: 100%;
    }

    .searchfield{
        width: 295px;
        color: #333;
    }

    td {
        padding: 5px;
        vertical-align: middle;
    }
    td > input {
        margin: 0px;
        width: 100%;
        padding: 1px 5px;
    }
    td > span {
        color: rgb(236, 240, 245);
    }
</style>
<style>
    .expand-enter-active {
        transition: all .3s ease;
    }
    .expand-leave-active {
        transition: all .3s ease;
    }
    .expand-enter, .expand-leave-to{
        transform: translateY(-10px);
        opacity: 0;
    }
</style>



// WEBPACK FOOTER //
// src/components/menu-components/SearchForm.vue?282b2b85